/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGemMint.vue?vue&type=template&id=f3f886c8"
import script from "./popGemMint.vue?vue&type=script&lang=js"
export * from "./popGemMint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports